import { Avatar, List } from 'antd';
import { CatalogTranscription } from 'config/constants/transcription.constant';
import React, { useMemo } from 'react';
import { Item } from 'store/models/cart.model';
import styles from './style.module.scss';

type ProductListItemProps = {
  item: Item;
  extraContent?: React.ReactNode;
};

const ProductListItem: React.FC<ProductListItemProps> = ({ item: { product, quantity, variant }, extraContent }) => {
  const mainImage = useMemo(() => variant.images?.find((image) => image.isMain), [variant.images]);

  const productDescription = useMemo(
    () => (
      <div className={styles['product-list-item-description-container']}>
        <p>
          {CatalogTranscription.SELECTED_OPTION}: <b>{variant.option}</b>
        </p>
        <p>
          {quantity} x {variant.priceFormatted || '-'}
        </p>
      </div>
    ),
    [variant, quantity],
  );

  return (
    <List.Item extra={extraContent}>
      <List.Item.Meta title={product.name} description={productDescription} avatar={<Avatar src={mainImage?.mobileImage} />} />
    </List.Item>
  );
};

export default ProductListItem;
